const domain = import.meta.env.REACT_APP_API_DOMAIN_DLGO;
const docsDomain = 'docs.dlocalgo.com';
const checkoutDomain = import.meta.env.REACT_APP_API_CHECKOUT_DOMAIN_DLGO;

export const Urls = {
  api: {
    login: `${domain}/v1/auth/authenticate`,
    twoFactorVerifyLogin: `${domain}/v1/auth/2fa/verify`,
    logout: `${domain}/v1/auth/logout`,
    refreshLogin: `${domain}/v1/auth/refresh_token`,
    signUp: `${domain}/v1/users`,
    userMe: `${domain}/v1/users/me`,
    merchantMe: `${domain}/v1/merchants/me`,
    impersonateMerchant: `${domain}/v1/impersonate/generate-token`,
    exitImpersonation: `${domain}/v1/auth/impersonate/exit`,
    companyInformation: `${domain}/v1/merchants/:id/company`,
    companyInformationV2: `${domain}/v2/merchants/:id/company`,
    paymentMethods: `${domain}/v1/merchants/:id/payment_methods`,
    paymentMethodsFilter: `${domain}/v1/payment_methods/filter/:type/:country`,
    allPaymentMethods: `${domain}/v1/payment_methods/all`,
    addPaymentMethods: `${domain}/v1/payment_methods/enable`,
    deletePaymentMethods: `${domain}/v1/payment_methods/disable`,
    calculator: `${domain}/v1/payment_methods/calculator`,

    validateMerchantCollaborator: `${domain}/v1/split/verify_user`,
    createCollaboration: `${domain}/v1/split/create`,
    splitCollaborations: `${domain}/v1/split/collaborations`,
    splitCollaborationAction: `${domain}/v1/split/collaborations/action`,
    cancelSplitCollaboration: `${domain}/v1/split/collaborations/cancel`,

    exportSplitsCsv: `${domain}/v1/split/collaborations/export/csv`,
    exportSplitsExcel: `${domain}/v1/split/collaborations/export/excel`,

    marketingConfig: `${domain}/v1/merchant-marketing`,

    availabilityDays: `${domain}/v1/payment_methods/availability_days`,
    installmentsCountryInfos: `${domain}/v1/payment_methods/installments/info`,
    enableInstallmentsCountry: `${domain}/v1/payment_methods/installments/enable/:country`,
    disableInstallmentsCountry: `${domain}/v1/payment_methods/installments/disable/:country`,

    addCountriesPaymentMethods: `${domain}/v1/payment_methods/enable/country`,
    deleteCountriesPaymentMethods: `${domain}/v1/payment_methods/disable/country`,
    paymentInfo: `${domain}/v1/payment_infos`,
    industries: `${domain}/v1/merchant_industries`,
    missingDocuments: `${domain}/v2/merchants/:merchantId/missing_documents`,
    subscriptionPrices: `${domain}/v1/subscription_prices`,
    subscriptionPayments: `${domain}/v1/subscription_payments/all`,
    cancelSubscription: `${domain}/v1/payment_infos/cancel`,

    allChargebacks: `${domain}/v1/chargebacks/all`,
    exportChargebacks: `${domain}/v1/chargebacks/export`,
    exportChargebacksExcel: `${domain}/v1/chargebacks/export/excel`,
    uploadChargebackDocument: `${domain}/v1/chargebacks/:id/document`,

    allCheckoutLogs: `${domain}/v1/checkout-logs/all`,
    allTransactions: `${domain}/v1/checkouts/search`,
    transactionsStatementData: `${domain}/v1/merchant_account_balance`,
    preChargebackForm: `${domain}/v1/transactions/pre-chargeback-form`,
    exportTransactions: `${domain}/v1/transactions/export`,
    exportTransactionsExcel: `${domain}/v1/transactions/export/excel`,
    affiliationsInfo: `${domain}/v1/transactions/affiliations/dash`,
    balances: `${domain}/v1/balances`,
    emailValidation: `${domain}/v1/users/send_validation_email`,
    confirmEmail: `${domain}/v1/users/confirm_validation_email`,
    allCheckoutThemes: `${domain}/v1/checkout-theme/all`,
    createCheckoutTheme: `${domain}/v1/checkout-theme`,
    toggleCheckoutTheme: `${domain}/v1/checkout-theme/toggle/:id`,
    allSettlements: `${domain}/v1/settlements/all`,
    settlementDetailExportPDF: `${domain}/v1/settlements/export/:id`,
    allBankAccounts: `${domain}/v1/settlements/bank_account/all`,
    deleteBankAccount: `${domain}/v1/settlements/bank_account`,
    documentTypes: `${domain}/v1/document_types`,
    validateDocument: `${domain}/v1/document_types/validate`,
    addBeneficiary: `${domain}/v1/settlements/bank_account`,
    addBeneficiaryWithDocument: `${domain}/v1/settlements/bank_account/with_document`,
    requestSettlement: `${domain}/v1/settlements`,
    currencies: `${domain}/v1/currencies`,
    createOneTimePaymentLink: `${domain}/v1/checkout/direct`,
    createRecurringPaymentLink: `${domain}/v1/checkout/recurring`,
    enableRecurringPaymentLink: `${domain}/v1/checkout/recurring/:token/enable`,
    disableRecurringPaymentLink: `${domain}/v1/checkout/recurring/:token/disable`,
    integrationKeys: `${domain}/v1/merchants/:id/integration_details`,
    allRefunds: `${domain}/v1/refunds/search`,
    refundDetail: `${domain}/v1/refunds/:id`,
    refundDetailExportPDF: `${domain}/v1/refunds/export/:id`,
    exportRefunds: `${domain}/v1/refunds/export`,
    exportRefundsExcel: `${domain}/v1/refunds/export/excel`,
    banks: `${domain}/v1/banks`,
    requestRefunds: `${domain}/v1/refunds`,
    allPayouts: `${domain}/v1/payouts/search`,
    payoutDetail: `${domain}/v1/payouts/:id`,
    payoutDetailExportPDF: `${domain}/v1/payouts/export/:id`,
    exportPayoutsCSV: `${domain}/v1/payouts/export/all/CSV`,
    exportPayoutsExcel: `${domain}/v1/payouts/export/all/XLSX`,
    exportPayoutsPDF: `${domain}/v1/payouts/export/all/PDF`,
    requestPayouts: `${domain}/v1/payouts`,
    validatePartialPayout: `${domain}/v1/payouts/validate`,
    payoutRequiredFields: `${domain}/v1/payouts/requirements`,
    payoutCountryConfigurations: `${domain}/v1/payouts/country-configurations`,
    payoutFee: `${domain}/v1/payouts/fee`,
    verifyOtpConfigured: `${domain}/v1/payouts/verify-otp-configured`,
    confirmPayout: `${domain}/v1/payouts`,
    sendPasswordReset: `${domain}/v1/users/send_password_reset_email`,
    confirmPasswordReset: `${domain}/v1/users/confirm_password_reset_email`,
    uploadLogo: `${domain}/v1/merchants/:id/logo`,
    deleteLogo: `${domain}/v1/merchants/:id/logo`,
    userUpdate: `${domain}/v1/users/update`,
    changePassword: `${domain}/v1/users/update_password`,
    twoFactorSetup: `${domain}/v1/auth/2fa/setup`,
    twoFactorConfirm: `${domain}/v1/auth/2fa/confirm`,
    twoFactorDisable: `${domain}/v1/auth/2fa/disable`,
    kycLevels: `${domain}/v1/merchants/kyc_levels`,
    allClients: `${domain}/v1/clients`,
    clientDetail: `${domain}/v1/clients/:clientId`,
    exportClientsCsv: `${domain}/v1/clients/export`,
    exportClientsExcel: `${domain}/v1/clients/export/excel`,
    deleteClient: `${domain}/v1/merchants/:id/clients/:clientId`,
    allOneTimePaymentLinks: `${domain}/v1/payment_links/all`,
    allRecurringPaymentLinks: `${domain}/v1/checkout/recurring/all`,
    shopifySetTestMode: `${domain}/v1/merchants/shopify/testmode`,
    jumioKycFlow: `${domain}/v2/merchants/:id/kyc_flow`,
    kyc2ValidationInit: `${domain}/v2/merchants/:id/kyc2/init`,
    reportsTransactionsSummary: `${domain}/v1/merchant_metrics/:days/header`,
    reportsTransactionsPaymentVolume: `${domain}/v1/merchant_metrics/:days/payment_volume`,
    reportsTransactionsByCountry: `${domain}/v1/merchant_metrics/:days/transactions_by_countries`,
    reportsTransactionsByPaymentSolution: `${domain}/v1/merchant_metrics/:days/transactions_by_payment_solution`,
    reportsTransactionsByPaymentMethod: `${domain}/v1/merchant_metrics/:days/transactions_by_payment_method`,
    createPlan: `${domain}/v1/subscription/plan`,
    allPlans: `${domain}/v1/subscription/plan/all`,
    allSubscriptions: `${domain}/v1/subscription/all`,
    createUpdateSubscriptionPlan: `${domain}/v1/subscription/plan`,
    deactivateSubscription: `${domain}/v1/subscription/:subscriptionId/deactivate`,
    deactivatePlan: `${domain}/v1/subscription/plan/:planId/deactivate`,

    merchantUsers: `${domain}/v1/merchants/me/users`,
    deleteMerchantUser: `${domain}/v1/users/:merchantUserId`,
    restoreMerchantUser: `${domain}/v1/users/:merchantUserId/restore`,
    resendInvite: `${domain}/v1/users/:merchantUserId/resend-invitation`,
    swapOwnerRole: `${domain}/v1/users/:merchantUserId/swap_owner`,
    inviteUser: `${domain}/v1/users/invitations`,
    confirmInvitationPassword: `${domain}/v1/users/confirm_invitation_password`,

    getKycDocuments: `${domain}/kyc/documents`,
    uploadKycDocuments: `${domain}/kyc/documents/upload`,
  },
  checkoutApi: {
    confirmPayment: `${checkoutDomain}/v1/checkout/confirm`,
    paymentInfo: `${checkoutDomain}/v1/checkout/`,
    dataRequired: `${checkoutDomain}/v1/checkout/payment_method/:id`,
  },
  paymentMethodsSquare: 'https://static.directopago.com/payment_method/square/:code.svg',
  paymentMethodsWide: 'https://static.directopago.com/payment_method/wide/:code.png',
  flags: 'https://static.directopago.com/flags/:code.svg',
  roundedFlags: 'https://static.directopago.com/flags_rounded/:code.svg',
  roundedFlagsFallback: 'https://hatscripts.github.io/circle-flags/flags/:code.svg',
  faq: {
    es: 'https://intercom.help/dlocalgo/es/',
    en: 'https://intercom.help/dlocalgo/en/',
    pt: 'https://intercom.help/dlocalgo/pt-BR/',
  },
  feedback: {
    es: 'https://docs.google.com/forms/d/19IW32WqlnSzkSnCw0DO5O4lfn2xP9RXmSy3Kb3HDcfM/viewform',
    en: 'https://docs.google.com/forms/d/e/1FAIpQLSdEZkYXJvijnjgA3fsU5SOuogP9StkqQAiWBFLptp5ItUWC_Q/viewform',
    pt: 'https://docs.google.com/forms/d/e/1FAIpQLScW6OA5npI0rvOWltDP778OvVq9MF5L2kchcMIuZutT4WYWdg/viewform',
  },
  checkoutLogsHelp: {
    es: `https://helpcenter.dlocalgo.com/es/articles/10157933-que-hacer-en-este-caso`,
    en: `https://helpcenter.dlocalgo.com/en/articles/10157933-what-to-do-in-this-case`,
    pt: `https://helpcenter.dlocalgo.com/pt-BR/articles/10157933-o-que-fazer-nesse-caso`,
  },
  magentoAddDP: 'https://marketplace.magento.com/dlocal-d-local-go.html',
  shopifyAddDP: 'https://apps.shopify.com/dlocal-go-offsite-payments',
  woocommercePlugin: 'https://wordpress.org/plugins/dlocal-go-payments-for-woocommerce/',
  prestaShopDownloadPlugin: 'https://static.dlocalgo.com/plugins/prestashop/dlocalgo.zip',
  docs: {
    firstSteps: {
      es: `https://helpcenter.dlocalgo.com/es/articles/9421580-primeros-pasos-en-dlocal-go`,
      pt: `https://helpcenter.dlocalgo.com/pt-BR/articles/9421580-primeiros-passos-no-dlocal-go`,
      en: `https://helpcenter.dlocalgo.com/en/articles/9421580-getting-started-with-dlocal-go`,
    },
    shopifyIntegration: {
      es: `https://intercom.help/dlocalgo/es/articles/7336476-guia-de-instalacion-del-checkout-redirect-en-shopify`,
      pt: `https://intercom.help/dlocalgo/pt-BR/articles/7336476-guia-de-instalacao-do-checkout-transparente-da-shopify`,
      en: `https://intercom.help/dlocalgo/en/articles/7336476-shopify-installation-guide`,
    },
    teaserIntegrations: {
      es: `https://forms.gle/88rKNRxMnUsMTRyK9`,
      pt: `https://forms.gle/88rKNRxMnUsMTRyK9`,
      en: `https://forms.gle/88rKNRxMnUsMTRyK9`,
    },
    shopifyTransparentIntegration: `https://${docsDomain}/v/pt`,
    magentoIntegration: {
      es: `https://intercom.help/dlocalgo/es/articles/7435866-guia-de-instalacion-del-checkout-redirect-en-magento`,
      en: `https://intercom.help/dlocalgo/en/articles/7435866-magento-checkout-redirect-installation-guide`,
      pt: `https://intercom.help/dlocalgo/en/articles/7435866-magento-checkout-redirect-installation-guide`,
    },
    woocommerceIntegration: {
      es: `https://intercom.help/dlocalgo/es/articles/7336479-guia-de-instalacion-del-checkout-redirect-en-woocommerce`,
      en: `https://intercom.help/dlocalgo/en/articles/7336479-woocommerce-checkout-redirect-installation-guide`,
      pt: `https://intercom.help/dlocalgo/pt-BR/articles/7336479-guia-de-instalacao-do-checkout-redirect-na-woocommerce`,
    },
    woocommerceIntegrationTest: {
      es: `https://intercom.help/dlocalgo/es/articles/7336479-guia-de-instalacion-del-checkout-redirect-en-woocommerce#h_7a58c36aeb`,
      en: `https://intercom.help/dlocalgo/en/articles/7336479-woocommerce-checkout-redirect-installation-guidet#h_da2e690964`,
      pt: `https://intercom.help/dlocalgo/pt-BR/articles/7336479-guia-de-instalacao-do-checkout-redirect-na-woocommerce#h_beae6a4323`,
    },
    prestaShopIntegration: {
      es: `https://intercom.help/dlocalgo/es/articles/7336480-guia-de-instalacion-del-checkout-redirect-en-prestashop`,
      en: `https://intercom.help/dlocalgo/en/articles/7336480-prestashop-installation-guide`,
      pt: `https://intercom.help/dlocalgo/pt-BR/articles/7336480-guia-de-instalacao-do-checkout-redirect-na-prestashop`,
    },
    hostingerIntegration: {
      es: `https://helpcenter.dlocalgo.com/es/articles/9265796-integracion-de-dlocal-go-en-hstore-de-hostinger`,
      en: `https://helpcenter.dlocalgo.com/en/articles/9265796-integration-of-dlocal-go-in-hostinger-s-hstore`,
      pt: `https://helpcenter.dlocalgo.com/pt-BR/articles/9265796-integracao-do-dlocalgo-a-hstore-da-hostinger`,
    },
    apiIntegration: `https://${docsDomain}/integration-api/`,
    levels: {
      es: `https://helpcenter.dlocalgo.com/es/articles/6960204-que-informacion-debo-dar`,
      pt: `https://helpcenter.dlocalgo.com/pt-BR/articles/6960204-qual-a-documentacao-que-preciso-fornecer`,
      en: `https://helpcenter.dlocalgo.com/en/articles/6960204-required-documentation`,
    },
    integrations: `https://${docsDomain}/integraciones`,
    paymentLink: `https://${docsDomain}/cobrar-con-link-de-pago`,
    paymentButton: `https://intercom.help/dlocalgo/es/collections/3963107-boton-de-pago`,
  },
};
